import { render, staticRenderFns } from "./StudentListRequest.vue?vue&type=template&id=3eb35d1e&scoped=true&"
import script from "./StudentListRequest.vue?vue&type=script&lang=js&"
export * from "./StudentListRequest.vue?vue&type=script&lang=js&"
import style0 from "./StudentListRequest.vue?vue&type=style&index=0&id=3eb35d1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb35d1e",
  null
  
)

export default component.exports